export const addDelimeterBetweenItems = (items, delimeter = ' ') => {
  return items.reduce((result, currentItem, index) => {
    if(index !== items.length - 1){
      return `${result}${currentItem}${delimeter}`
    }
    // do not add delimeter to last item
    return `${result}${currentItem}`
  }, '')
}


// WEBPACK FOOTER //
// ./src/helpers/stringHelpers.js